// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__86new","info":"Note_info__6xAla","note":"Note_note__3AhOl","actions":"Note_actions__15lp3"};